import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { GuideValueSection } from './components/GuideValueSection';
import { TrustSection } from './components/TrustSection';
import { BonusSection } from './components/BonusSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-gold/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPointsSection data-id="element-3" />
        <GuideValueSection data-id="element-4" />
        <TrustSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}